import { render, staticRenderFns } from "./CarList.vue?vue&type=template&id=66b28594&scoped=true"
import script from "./CarList.vue?vue&type=script&lang=js"
export * from "./CarList.vue?vue&type=script&lang=js"
import style0 from "./CarList.vue?vue&type=style&index=0&id=66b28594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b28594",
  null
  
)

export default component.exports